import { type IApiResponse, type IGetReportsState } from '@/helpers/types';
import { getCommandQuery, type IGetQuery } from '@/store/actions/api-utils';

import { coreApiSlice } from '../apiSlice';

const reportApiSlice = coreApiSlice.injectEndpoints({
	endpoints: (builder) => ({
		createReport: builder.mutation<IApiResponse, { title: string; body: string }>({
			query: (body) => ({
				method: 'POST',
				url: '/Report',
				body,
			}),
		}),
		getReport: builder.query<IApiResponse<IGetReportsState[]>, IGetQuery>({
			query: ({ paged, query }) => ({
				url: `/Report${getCommandQuery(paged, ...(query || []))}`,
			}),
		}),
		getReportById: builder.query<IApiResponse<IGetReportsState>, { id: string }>({
			query: ({ id }) => ({
				url: `/Report/${id}`,
			}),
		}),
		updateReportById: builder.mutation<IApiResponse, { id: string; title: string; body: string }>({
			query: ({ id, title, body }) => ({
				url: `/Report/${id}`,
				method: 'PUT',
				body: {
					title,
					body,
				},
			}),
		}),
		getReportsMarkedAsResolved: builder.query<IApiResponse, { id: string }>({
			query: ({ id }) => ({
				url: `/Report/mark-as-resolved/${id}`,
			}),
		}),
	}),
});

export const {
	useCreateReportMutation,
	useGetReportQuery,
	useGetReportByIdQuery,
	useGetReportsMarkedAsResolvedQuery,
	useLazyGetReportsMarkedAsResolvedQuery,
	useUpdateReportByIdMutation,
} = reportApiSlice;
